import { render, staticRenderFns } from "./Auth0CustomLoginPopup.vue?vue&type=template&id=8c24ffa0&"
import script from "./Auth0CustomLoginPopup.vue?vue&type=script&lang=js&"
export * from "./Auth0CustomLoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./Auth0CustomLoginPopup.vue?vue&type=style&index=0&id=8c24ffa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports